import { AppSettings } from "@/AppSettings";
import { SourceDataEventStatus } from "@/api/dtos";

const sourceDataEventStatusToIcon = (status?: SourceDataEventStatus) => {
    switch (status) {
        case SourceDataEventStatus.Complete:
            return AppSettings.icons.statusComplete;
        case SourceDataEventStatus.Locked:
            return AppSettings.icons.statusLocked;
        case SourceDataEventStatus.Skipped:
            return AppSettings.icons.statusSkipped;
        case SourceDataEventStatus.Started:
            return AppSettings.icons.statusStarted;
        case SourceDataEventStatus.Scheduled:
            return AppSettings.icons.statusScheduled;
        case SourceDataEventStatus.None:
        default:
            return AppSettings.icons.statusNone
    }
}

export default sourceDataEventStatusToIcon;